<ng-container *ngIf="abierto">
  <div class="backdrop"></div>
  <div class="modalPanelAdmin animated {{animacion}}">
    <div class="contenido">
      <!-- Título -->
      <div class="encabezadoModal">
        <div class="modalTituloSimple">{{ 'Seleccionar alumnos'}}</div>
      </div>
      <div class="modalContenido">
        <!-- datos -->
        <div>
          <div class="divisor8"></div>
          <div>
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <inputCustom
                  [titulo]="'Matricula'"
                  [(ngModel)]="entidad.matricula"
                  [verError]="false"
                ></inputCustom>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <inputCustom
                  [titulo]="'Nombre'"
                  [(ngModel)]="entidad.nombre"
                  [verError]="false"
                ></inputCustom>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <inputCustom
                  [titulo]="'Ap. paterno'"
                  [(ngModel)]="entidad.apellidopaterno"
                  [verError]="false"
                ></inputCustom>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <inputCustom
                  [titulo]="'Ap. materno'"
                  [(ngModel)]="entidad.apellidomaterno"
                  [verError]="false"
                ></inputCustom>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <dropdownCustom
                  [titulo]="'Nivel'"
                  [(ngModel)]="entidad.nivelid"
                  (ngModelChange)="setGrado(entidad.nivelid)"
                  [opciones]="SelNivel"
                  [valorName]="'nivelid'"
                  [displayValor]="'nombre'"
                  [buscar]="false"
                ></dropdownCustom>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <dropdownCustom
                  [titulo]="'Grado'"
                  [(ngModel)]="entidad.gradoid"
                  (ngModelChange)="setGrupo(entidad.gradoid)"
                  [opciones]="SelGrado"
                  [valorName]="'gradoid'"
                  [displayValor]="'nombre'"
                  [buscar]="false"
                ></dropdownCustom>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <dropdownCustom
                  [titulo]="'Grupo'"
                  [(ngModel)]="entidad.grupoid"
                  [opciones]="SelGrupo"
                  [valorName]="'grupoid'"
                  [displayValor]="'nombre'"
                  [buscar]="false"
                ></dropdownCustom>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <dropdownCustom
                  [titulo]="'Estatus'"
                  [(ngModel)]="entidad.alumnoestatusid"
                  [opciones]="SelEstatus"
                  [valorName]="'alumnoestatusid'"
                  [displayValor]="'nombre'"
                  [buscar]="false"
                ></dropdownCustom>
              </div>
            </div>

            <!-- Botones de filtrado -->
            <div class="row">
              <div class="col-12">
                <div class="panelBotonesFiltro">
                  <button
                    class="boton botonSM filledBlanco"
                    (click)="LimpiarFiltros()"
                  >
                    {{'Limpiar' | translate}}
                  </button>

                  <div class="divisorH16"></div>

                  <button class="boton botonSM filled" (click)="Buscar()">
                    {{'Consultar' | translate}}
                  </button>
                </div>
              </div>
            </div>

            <div class="divisorgris"></div>
            <div class="divisor16"></div>

            <!-- datos -->
            <dx-data-grid
            #grid
              (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
              id="tabla"
              [columnAutoWidth]="true"
              [dataSource]="dataTable"
              [showColumnHeaders]="true"
            >
              <dxo-search-panel
                [visible]="true"
                [width]="240"
                placeholder="{{'Buscar' | translate}}"
              >
              </dxo-search-panel>

              <dxo-paging
                [pageSize]="sistemaService.tablaPaginacion"
              ></dxo-paging>
              <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

              <dxo-pager
                [visible]="true"
                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                [displayMode]="sistemaService.tablaPaginacionModo"
                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                [showInfo]="sistemaService.tablaPaginacionInfo"
                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion"
              >
              </dxo-pager>

              <dxo-selection
                            [selectAllMode]="'allPages'"
                            [showCheckBoxesMode]="'always'"
                            mode="multiple"
                          ></dxo-selection>
              <dxi-column dataField="matricula" caption="Matrícula">
              </dxi-column>
              <dxi-column dataField="nombre" caption="Nombre"> </dxi-column>
              <dxi-column dataField="apellidopaterno" caption="Ap. paterno">
              </dxi-column>
              <dxi-column dataField="apellidomaterno" caption="Ap. materno">
              </dxi-column>
              <dxi-column dataField="nivel" caption="Nivel"> </dxi-column>
              <dxi-column dataField="grado" caption="Grado"> </dxi-column>
              <dxi-column dataField="grupo" caption="Grupo"> </dxi-column>

              <dxi-column dataField="estatus" caption="Estatus"> </dxi-column>
            </dx-data-grid>
          </div>
        </div>
      </div>

      <!-- footer -->
      <div class="modalFooter">
        <div class="contenidoFooter botonesIzq">
          <!-- editar -->
          <div class="botonDerecha">
            <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
              Cancelar
            </button>
            <div class="divisorH16"></div>
            <button class="boton botonSM filled" (click)="Guardar()">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
